import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "panel-container" }
const _hoisted_2 = {
  class: "row mt-5 ml-auto demo",
  style: {"margin-top":"0px !important","margin-bottom":"30px"}
}
const _hoisted_3 = ["disabled"]
const _hoisted_4 = { class: "rowFrame" }
const _hoisted_5 = { class: "col-4 contTitle" }
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "col-2 contCnt" }
const _hoisted_8 = ["disabled", "onClick"]
const _hoisted_9 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Mo_modal_n_force = _resolveComponent("Mo_modal_n_force")!

  return (_openBlock(), _createBlock(_component_Mo_modal_n_force, { ref: "modal_claimNo" }, {
    title: _withCtx(() => _cache[2] || (_cache[2] = [
      _createTextVNode("請求書NR取得")
    ])),
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[4] || (_cache[4] = _createElementVNode("div", {
          class: "loader",
          style: {"text-align":"center"}
        }, [
          _createElementVNode("i", { class: "fal fa-spinner-third fa-spin-4x fs-xxl" })
        ], -1)),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary waves-effect waves-themed",
            disabled: _ctx.btnDisable,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.add()))
          }, " 請求番号追加 ", 8, _hoisted_3)
        ]),
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "row listRow" }, [
          _createElementVNode("div", { class: "col-4 contTitle" }, "請求番号"),
          _createElementVNode("div", { class: "col-6 contTitle" }, "状態"),
          _createElementVNode("div", { class: "col-2 contTitle" }, "削除")
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.delegate.items, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "row listRow",
              key: item.c_claim_id!
            }, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("input", {
                  type: "text",
                  style: {"border":"none"},
                  class: "form-control form-control-sm",
                  value: item.c_claim_number,
                  disabled: ""
                }, null, 8, _hoisted_6)
              ]),
              _cache[3] || (_cache[3] = _createElementVNode("div", { class: "col-6 contCnt" }, [
                _createElementVNode("span", {
                  class: "badge badge-warning badge-pill",
                  style: {"font-size":"1em"}
                }, "未作成")
              ], -1)),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-xs btn-danger waves-effect waves-themed",
                  disabled: _ctx.btnDisable,
                  onClick: ($event: any) => (_ctx.upd(item.c_claim_id!))
                }, " 削除 ", 8, _hoisted_8)
              ])
            ]))
          }), 128))
        ])
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-secondary waves-effect waves-themed",
        "data-dismiss": "modal",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.closeModal4ClaimNo())),
        disabled: _ctx.btnDisable
      }, " 閉じる ", 8, _hoisted_9)
    ]),
    _: 1
  }, 512))
}